import { addMonths, format } from "date-fns";
import { enUS } from "date-fns/locale";
import Holidays from "date-holidays";

export function getPeriodNameByPeriod(period) {
    const dt = new Date(period.year, period.month, 1);
    return format( dt, 'MMMM yyyy', {locale: enUS}).replace(/./,c => c.toUpperCase());
}

export function getMonthNameByPeriod(period) {
    const dt = new Date(period.year, period.month, 1);
    return format( dt, 'MMMM', {locale: enUS}).replace(/./,c => c.toUpperCase());
}

export function getPeriodAddMonth(period, months){
    const dt = new Date(period.year, period.month-1, 1);
    const ndt = addMonths(dt, months);
    return(getPeriod(ndt.getFullYear(),ndt.getMonth()+1));
}

export function getPeriod(year, month){
    return ({year,month});
}
      
export function getWorkDaysInMonth(period, country = "NO") {

    
  const holidays = new Holidays(country);

  const start = new Date(period.year, period.month , 1);
  const end = new Date(period.year, period.month+1, 0);

  let workDays = 0;

for (
  let current = new Date(start);
  current <= end;
  current.setDate(current.getDate() + 1)
) {
  const day = current.getDay();

  if (day === 0 || day === 6) {
    continue;
  }

  const holiday = holidays.isHoliday(current);
  
  if (  holiday &&
        holiday.some((h) => h.type === "public")) {
        continue;
  }

    if ( isVariantHoliday(current)) {
        continue;
    }

  workDays++;
}
  return workDays;
}

function isVariantHoliday(date) {
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return (
    (month === 12 && day === 24) ||
    (month === 12 && day === 31)
  );
}